import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, message, Select, Modal, Form, Input } from 'antd';
import {
    LineChartOutlined,
    BankOutlined,
    FileTextOutlined,
    TeamOutlined,
    SecurityScanOutlined,
    UserOutlined,
    LogoutOutlined,
    DownOutlined,
    KeyOutlined,
    EditOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import request from '../../utils/request';
import { getSuiteList } from '../../api/suite';
import { logout, changePassword, editName } from '../../api/admin';
import { useSuite } from '../../context/SuiteContext';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;
const { Option } = Select;

const items = [
    // {
    //     key: 'dashboard',
    //     icon: <LineChartOutlined />,
    //     label: '数据概览',
    //     children: [
    //         { key: '/dashboard/overview', label: '数据概览' },
    //         { key: '/dashboard/ads', label: '广告报表' },
    //         { key: '/dashboard/products', label: '产品报表' },
    //         { key: '/dashboard/wecom', label: '企微报表' },
    //         { key: '/dashboard/visitors', label: '实时访客' },
    //         { key: '/dashboard/users', label: '用户报表' },
    //     ],
    // },
    {
        key: 'assets',
        icon: <BankOutlined />,
        label: '资产库',
        children: [
            { key: '/assets/materials', label: '素材库' },
            { key: '/assets/pages', label: '落地页' },
            // { key: '/assets/links', label: '投放链接库' },
            // { key: '/assets/products', label: '产品管理' },
            // { key: '/assets/crowd', label: '人群包管理' },
            // { key: '/assets/merchants', label: '商户号管理' },
        ],
    },
    // {
    //     key: 'landing',
    //     icon: <FileTextOutlined />,
    //     label: '落地页管理',
    //     children: [
    //         // { key: '/landing/pages', label: '落地页' },
    //         // { key: '/landing/forms', label: '表单管理' },
    //         // { key: '/landing/leads', label: '线索列表' },
    //         // { key: '/landing/reviews', label: '评价管理' },
    //     ],
    // },
    {
        key: 'private',
        icon: <TeamOutlined />,
        label: '企微管理',
        children: [
            { key: '/private/wecom', label: '企微授权' },
            { key: '/private/orders', label: '订单管理' },
            { key: '/private/links_cs', label: '获客链接' },
            { key: '/private/fans', label: '加粉明细' },

            // { key: '/private/projects', label: '项目管理' },
            // { key: '/private/leads', label: '项目线索' },
        ],
    },
    {
        key: 'firewall',
        icon: <SecurityScanOutlined />,
        label: '防水墙',
        children: [
            { key: '/firewall/whitelist', label: 'IP白名单' },
            { key: '/firewall/blacklist', label: 'IP黑名单' },
            // { key: '/firewall/rules', label: '屏蔽规则' },
            // { key: '/firewall/monitor', label: '计划监测' },
            // { key: '/firewall/comments', label: '评论列表' },
        ],
    },
    // {
    //     key: 'account',
    //     icon: <UserOutlined />,
    //     label: '广告账户',
    //     children: [
    //         { key: '/account/list', label: '账户列表' },
    //     ]
    // },
];

const MainLayout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userInfo, setUserInfo] = useState(null);
    const { suiteId, setSuiteId, suiteList, setSuiteList } = useSuite();
    const [openKeys, setOpenKeys] = useState(() => {
        // 从localStorage恢复菜单打开状态
        const saved = localStorage.getItem('menu_open_keys');
        return saved ? JSON.parse(saved) : [];
    });

    const handleMenuOpenChange = (keys) => {
        setOpenKeys(keys);
        // 保存到localStorage
        localStorage.setItem('menu_open_keys', JSON.stringify(keys));
    };

    useEffect(() => {
        const infoStr = localStorage.getItem('user_info');
        if (infoStr) {
            setUserInfo(JSON.parse(infoStr));
        }

        fetchSuiteList();
    }, []);

    const fetchSuiteList = async () => {
        try {
            const res = await getSuiteList({ is_show: 1 });
            if (res.code === 0 && res.data && res.data.length > 0) {
                setSuiteList(res.data);
                // Default select the first one if not set
                if (!suiteId) {
                    setSuiteId(res.data[0].suite_id);
                }
            }
        } catch (error) {
            console.error('Fetch suite list failed:', error);
        }
    };

    const [changePwdVisible, setChangePwdVisible] = useState(false);
    const [pwdForm] = Form.useForm();
    const [changeNameVisible, setChangeNameVisible] = useState(false);
    const [nameForm] = Form.useForm();

    const handleLogout = async () => {
        try {
            const token = localStorage.getItem('user_token');
            const res = await logout({ user_token: token });
            if (res.code === 0) {
                // messages handled by caller usually or just redirect
            } else {
                if (res.message) message.error(res.message);
            }
        } catch (error) {
            console.error('Logout error:', error);
            if (error.message) message.error(error.message);
        } finally {
            localStorage.removeItem('user_token');
            localStorage.removeItem('user_info');
            navigate('/login');
        }
    };

    const handleChangePwdClick = () => {
        setChangePwdVisible(true);
        pwdForm.resetFields();
    };

    const handleChangePwdSubmit = async () => {
        try {
            const values = await pwdForm.validateFields();
            const res = await changePassword({
                old_pass: values.old_pass,
                new_pass: values.new_pass,
                confirm_pass: values.confirm_pass
            });

            if (res.code === 0) {
                message.success('修改成功, 请重新登录');
                setChangePwdVisible(false);
                // Redirect to login
                localStorage.removeItem('user_token');
                localStorage.removeItem('user_info');
                navigate('/login');
            } else {
                message.error(res.message || '修改失败');
            }
        } catch (error) {
            console.error('Change password failed:', error);
            // Form validation errors throw here too
            if (error.errorFields) return;
            message.error(error.message || '修改失败');
        }
    };

    const handleChangeNameClick = () => {
        setChangeNameVisible(true);
        nameForm.setFieldsValue({
            nick_name: userInfo?.nick_name || userInfo?.user_name
        });
    };

    const handleChangeNameSubmit = async () => {
        try {
            const values = await nameForm.validateFields();
            const res = await editName({
                nick_name: values.nick_name
            });

            if (res.code === 0) {
                message.success('修改成功');
                setChangeNameVisible(false);
                // Update local storage and state
                const newUserInfo = { ...userInfo, nick_name: values.nick_name };
                setUserInfo(newUserInfo);
                localStorage.setItem('user_info', JSON.stringify(newUserInfo));
            } else {
                message.error(res.message || '修改失败');
            }
        } catch (error) {
            console.error('Change name failed:', error);
            if (error.errorFields) return;
            message.error(error.message || '修改失败');
        }
    };

    const userMenuItems = [
        {
            key: 'changeName',
            icon: <EditOutlined />,
            label: '修改昵称',
            onClick: handleChangeNameClick,
        },
        {
            key: 'changePwd',
            icon: <KeyOutlined />,
            label: '修改密码',
            onClick: handleChangePwdClick,
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            onClick: handleLogout,
        },
    ];

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider width={200} className="site-layout-sider">
                <div className="logo-container">
                    <div className="logo-icon">U</div>
                    <div className="logo-text">优量</div>
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    openKeys={openKeys}
                    onOpenChange={handleMenuOpenChange}
                    style={{ height: 'calc(100% - 64px)', borderRight: 0 }}
                    items={items}
                    onClick={({ key }) => navigate(key)}
                />
            </Sider>
            <Layout className="site-layout">
                <Header className="site-header">
                    {/* Header Left Content */}
                    <div />

                    {/* Header Right Content */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* Suite Selector */}
                        <Select
                            style={{ width: 200, marginRight: 24 }}
                            placeholder="选择应用"
                            value={suiteId}
                            onChange={val => setSuiteId(val)}
                            disabled
                        >
                            {suiteList.map(suite => (
                                <Option key={suite.suite_id} value={suite.suite_id}>
                                    {suite.suite_name}
                                </Option>
                            ))}
                        </Select>

                        {/* User Profile */}
                        <div style={{ cursor: 'pointer' }}>
                            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Avatar style={{ backgroundColor: '#ff6a00', marginRight: 8 }} icon={<UserOutlined />} />
                                    <span style={{ color: '#333', marginRight: 8 }}>{userInfo?.nick_name || userInfo?.user_name || 'User'}</span>
                                    <DownOutlined style={{ fontSize: '12px', color: '#999' }} />
                                </div>
                            </Dropdown>
                        </div>
                    </div>
                </Header>
                <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                    <div className="site-content">
                        {children}
                    </div>
                </Content>
            </Layout>

            <Modal
                title="修改密码"
                open={changePwdVisible}
                onOk={handleChangePwdSubmit}
                onCancel={() => setChangePwdVisible(false)}
                okText="确认"
                cancelText="取消"
                centered
            >
                <Form form={pwdForm} layout="vertical">
                    <Form.Item
                        name="old_pass"
                        label="旧密码"
                        rules={[{ required: true, message: '请输入旧密码' }]}
                    >
                        <Input.Password placeholder="请输入旧密码" />
                    </Form.Item>
                    <Form.Item
                        name="new_pass"
                        label="新密码"
                        rules={[{ required: true, message: '请输入新密码' }]}
                    >
                        <Input.Password placeholder="请输入新密码" />
                    </Form.Item>
                    <Form.Item
                        name="confirm_pass"
                        label="确认密码"
                        dependencies={['new_pass']}
                        rules={[
                            { required: true, message: '请确认新密码' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('new_pass') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次输入的密码不一致'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="请再次输入新密码" />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="修改昵称"
                open={changeNameVisible}
                onOk={handleChangeNameSubmit}
                onCancel={() => setChangeNameVisible(false)}
                okText="保存"
                cancelText="取消"
                centered
            >
                <Form form={nameForm} layout="vertical">
                    <Form.Item
                        name="nick_name"
                        label="新昵称"
                        rules={[{ required: true, message: '请输入新昵称' }]}
                    >
                        <Input placeholder="请输入新昵称" />
                    </Form.Item>
                </Form>
            </Modal>
        </Layout>
    );
};

export default MainLayout;
